import Lottie from "lottie-react";
import imagesAnim from "../../../lottie/images.json";

export default function AwakenTab() {
  return (
    <>
      <div className="awaken-tab-wrap tab-wrapper-all">
        <div className="awaken-tab-wrap__text tab-wrapper-all__text">
          <h2>Strategy that Shines</h2>
          <p>
            For brands launching fresh, scaling up, or pivoting for what’s next,
            we cut through the noise to set a solid foundation.
          </p>
          <h4>Our strategic playbook includes:</h4>
          <ul>
            <li>Market analysis and audience profiling</li>
            <li>Brand positioning and messaging frameworks</li>
            <li>Go-to-market and launch tactics</li>
            <li>Campaign planning and performance roadmaps</li>
          </ul>
          <span>The dawning of marketing that truly works.  </span>
        </div>
        <div className="awaken-tab-wrap__anim tab-wrapper-all__anim">
          <Lottie animationData={imagesAnim} loop={false} />
        </div>
      </div>
    </>
  );
}
